import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { _HttpClient } from '@delon/theme';
import { URLS } from '../../../shared/constant/interface';
import { formatNumber } from '../../../shared/utils/common';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.less'],
})
export class VideoComponent implements OnInit {

static NAME = 'icc-msg-social-video';

  channelId: number;
  // ----------- 总**量 --------------
  // 总播放量
  playCount: number;
  playnumList: Array<string>;
  // 总点赞量
  likeCount: number;
  likenumList: Array<string>;
  // 总评论量
  commentCount: number;
  commentnumList: Array<string>;
  // 总分享量
  sharedCount: number;
  sharednumList: Array<string>;
  // ----------- 昨日**量 --------------
  // 昨日播放量
  yesterdayPlayCount: number;
  // 昨日点赞量
  yesterdayLikeCount: number;
  // 昨日评论量
  yesterdayCommentCount: number;
  // 昨日分享量
  yesterdaySharedCount: number;
  // ----------- 本月**量 --------------
  // 本月播放量
  monthPlayCount: number;
  // 本月点赞量
  monthLikeCount: number;
  // 本月评论量
  monthCommentCount: number;
  // 本月分享量
  monthSharedCount: number;

  // 显示数据
  displayYPC: any;
  displayYLC: any;
  displayYCC: any;
  displayYSC: any;

  displayMPC: any;
  displayMLC: any;
  displayMCC: any;
  displayMSC: any;

  total: any;
  month: any;
  yesterday: any;

  constructor(private route: ActivatedRoute, private http: _HttpClient) {}

  ngOnInit() {
    const params = this.route.snapshot.queryParams;
    this.channelId = params.channelId;
console.log(this.channelId)
    this.http.get(URLS.fetchTikTokVideoIndexStatData.url + '/' + this.channelId).subscribe(res => {
      if (res.status === 0 && res.data && res.data.length > 0) {
        if (res.data[0]) {
          this.total = res.data[0];
          this.playnumList = this.handleCount(this.total.broadcastTotal);
          this.likenumList = this.handleCount(this.total.praiseTotal);
          this.commentnumList = this.handleCount(this.total.commentTotal);
          this.sharednumList = this.handleCount(this.total.sharedTotal);
        }

        if (res.data[1]) {
          this.month = res.data[1];
          this.displayMPC = this.handlePreviousCount(this.month.broadcastTotal);
          this.displayMLC = this.handlePreviousCount(this.month.praiseTotal);
          this.displayMCC = this.handlePreviousCount(this.month.commentTotal);
          this.displayMSC = this.handlePreviousCount(this.month.sharedTotal);
        }

        if (res.data[2]) {
          this.yesterday = res.data[2];
          this.displayYPC = this.handlePreviousCount(this.yesterday.broadcastTotal);
          this.displayYLC = this.handlePreviousCount(this.yesterday.praiseTotal);
          this.displayYCC = this.handlePreviousCount(this.yesterday.commentTotal);
          this.displayYSC = this.handlePreviousCount(this.yesterday.sharedTotal);
        }
      }
    });

    /*     // 模拟数据-总播放量
    this.playCount = 252294;
    this.playnumList = this.handleCount(this.playCount);
    // 模拟数据-总点赞量
    this.likeCount = 29765;
    this.likenumList = this.handleCount(this.likeCount);
    // 模拟数据-总评论量
    this.commentCount = 12342;
    this.commentnumList = this.handleCount(this.commentCount);
    // 模拟数据-总分享量
    this.sharedCount = 9879;
    this.sharednumList = this.handleCount(this.sharedCount);
    // ---------------------------
    // 数据模拟-昨日播放量
    this.yesterdayPlayCount = 54232;
    this.displayYPC = this.handlePreviousCount(this.yesterdayPlayCount);
    // 数据模拟-昨日点赞量
    this.yesterdayLikeCount = 13232;
    this.displayYLC = this.handlePreviousCount(this.yesterdayLikeCount);
    // 数据模拟-昨日评论量
    this.yesterdayCommentCount = 122;
    this.displayYCC = this.handlePreviousCount(this.yesterdayCommentCount);
    // 数据模拟-昨日分享量
    this.yesterdaySharedCount = 98;
    this.displayYSC = this.handlePreviousCount(this.yesterdaySharedCount);
    // ---------------------------
    // 数据模拟-本月播放量
    this.monthPlayCount = 63424;
    this.displayMPC = this.handlePreviousCount(this.monthPlayCount);
    // 数据模拟-本月点赞量
    this.monthLikeCount = 23412;
    this.displayMLC = this.handlePreviousCount(this.monthLikeCount);
    // 数据模拟-本月评论量
    this.monthCommentCount = 3424;
    this.displayMCC = this.handlePreviousCount(this.monthCommentCount);
    // 数据模拟-本月分享量
    this.monthSharedCount = 424;
    this.displayMSC = this.handlePreviousCount(this.monthSharedCount); */
  }

  // 数据总量处理
  handleCount(count: any) {
    if (typeof count === 'string') {
      count = Number(count);
    }
    if (typeof count === 'number') {
      if (count > 10000) {
        const floorCount = Math.floor(count / 10000) + 'W+';
        const floorCountList = floorCount.split('');
        return floorCountList;
      } else {
        const numStrings = formatNumber(count);
        const countList = numStrings.split('');
        return countList;
      }
    }
  }

  // 昨日/本月数据处理
  handlePreviousCount(count: any) {
    if (typeof count === 'string') {
      count = Number(count);
    }
    if (typeof count === 'number') {
      if (count > 10000) {
        const floorCount = Math.floor(count / 10000);
        return floorCount + 'W+';
      } else {
        return formatNumber(count);
      }
    }
  }
}
